import { Route, UrlSegment } from '@angular/router';
import { ContentLayout } from './shell/layouts/content-layout/content-layout';
import { AuthenticationLayout } from './shell/layouts/authentication-layout/authentication-layout';
import { authGuard } from './core/guards/auth/auth.guard';

export const App_Route: Route[] = [
  { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
  // The Identity API emails reset links as <PasswordReset:ResetUrlBase>?token=… (default base
  // "/reset-password"); send them to the auth page, keeping the token query parameter.
  { path: 'reset-password', redirectTo: 'auth/reset-password', pathMatch: 'full' },
  {
    path: 'auth',
    component: AuthenticationLayout,
    loadChildren: () =>
      import('./features/authentication/authentication.routes').then((m) => m.authen),
  },
  {
    // Routes are case-sensitive, so a bookmarked or autocompleted "/Auth/Login" landed on the 404 page.
    // Any other casing of the auth pages goes to the real, lowercase route.
    matcher: (segments: UrlSegment[]) =>
      segments.length > 0 &&
      segments[0].path.toLowerCase() === 'auth' &&
      segments.some((segment) => segment.path !== segment.path.toLowerCase())
        ? { consumed: segments }
        : null,
    redirectTo: ({ url }) => '/' + url.map((segment) => segment.path.toLowerCase()).join('/'),
  },
  {
    // "/authentication/..." is the tenant portal's login path; browser autocomplete keeps offering it on this
    // port, so any casing of it goes to Master Admin's own auth pages instead of the 404 page.
    matcher: (segments: UrlSegment[]) =>
      segments.length > 0 && segments[0].path.toLowerCase() === 'authentication' ? { consumed: segments } : null,
    redirectTo: ({ url }) => '/auth/' + (url.slice(1).map((segment) => segment.path.toLowerCase()).join('/') || 'login'),
  },
  {
    path: '',
    component: ContentLayout,
    // The frame (header, side menu, footer) stays between pages; see ReloadRouteReuseStrategy.
    data: { keepFrame: true },
    canActivateChild: [authGuard],
    loadChildren: () => import('./shell/routes/content.routes').then((m) => m.content),
  },
  {
    path: '**',
    loadComponent: () => import('./features/errors/error404/error404').then((m) => m.Error404),
  },
];
